import React from 'react';
import { PencilIcon, TrashIcon, PlusIcon } from '@heroicons/react/24/outline';

const SpeakersList = ({
  speakers,
  onSelectSpeaker,
  onAddSpeaker,
  onRenameSpeaker,
  onDeleteSpeaker,
  className = '',
}) => {
  const speakerInitials = (name) =>
    (name || '?')
      .split(/\s+/)
      .map((p) => p[0])
      .filter(Boolean)
      .slice(0, 2)
      .join('')
      .toUpperCase();

  return (
    <div className={`te-speakers ${className}`}>
      <div className="te-speakers-head">
        <h3 className="te-sidebar-section-title" style={{ margin: 0 }}>
          Speakers ({speakers.length})
        </h3>
        {onAddSpeaker && (
          <button
            onClick={onAddSpeaker}
            className="te-btn te-btn-ghost te-btn-compact"
            title="Add new speaker"
          >
            <PlusIcon className="h-3.5 w-3.5" />
            Add
          </button>
        )}
      </div>

      {speakers.length === 0 ? (
        <p className="te-sidebar-note" style={{ textAlign: 'left' }}>No speakers found.</p>
      ) : (
        <ul className="te-speakers-list">
          {speakers.map((speaker) => (
            <li key={speaker.name} className="te-speaker-row">
              <button
                onClick={() => onSelectSpeaker?.(speaker.name)}
                className="te-speaker-main"
                title={`Assign selected blocks to ${speaker.name}`}
              >
                <span className="te-speaker-avatar">{speakerInitials(speaker.name)}</span>
                <span className="te-speaker-name">{speaker.name}</span>
                <span className="te-speaker-count">{speaker.count}</span>
              </button>
              <div className="te-speaker-actions">
                {onRenameSpeaker && (
                  <button
                    onClick={() => onRenameSpeaker(speaker.name)}
                    className="te-icon-btn"
                    title="Rename speaker"
                  >
                    <PencilIcon className="h-3.5 w-3.5" />
                  </button>
                )}
                {onDeleteSpeaker && (
                  <button
                    onClick={() => onDeleteSpeaker(speaker.name)}
                    className="te-icon-btn te-icon-btn-danger"
                    title="Delete & merge speaker"
                  >
                    <TrashIcon className="h-3.5 w-3.5" />
                  </button>
                )}
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default SpeakersList;
